import InlineInputAddress from "../../../components/Common/InlineInputAddress";
import { useForm } from "react-hook-form";
import { useState } from "react";
import { useEffect } from "react";
import EmailAddressForm from "../UserComponents/userProfileForm/EmailAddressForm"
import { useSelector, useDispatch } from "react-redux";
import { updateUserInfoAsync } from "../userSlice";
import Loader from "../../../components/Common/Loader";
import { isLoadingUserSlice } from "../userSlice";

const nameValidate = {
    required: "Firstname is required.",
    minLength: { value: 2, message: 'Please enter valid name.' }
}

function UserProfile() {
    const { register, handleSubmit, getValues, setValue, formState: { isValid, isSubmitting } } = useForm();
    const [personalInfoEditMode, setpersonalInfoEditMode] = useState(false);
    const [defaultValues, setDefaultValues] = useState({ 'firstname': '', lastname: '' })
    const dispatch = useDispatch();
    const userDetails = useSelector((state) => state.user.userInfo);
    const loading = useSelector(isLoadingUserSlice);

    const toggleEditMode = () => {
        const firstNameValue = getValues("firstname");
        const lastNameValue = getValues("lastname");
        if (firstNameValue === "" || lastNameValue === "") { //This run when user backspace the input default values and click cancel
            setValue('firstname', defaultValues.firstname);
            setValue('lastname', defaultValues.lastname);
        }
        setpersonalInfoEditMode(!personalInfoEditMode);
    };

    const submitInfo = (data) => {
        if (isValid) {
            dispatch(updateUserInfoAsync(data)).then(() => {
                setpersonalInfoEditMode(!personalInfoEditMode);
            })

        }
    }

    useEffect(() => {
        if (userDetails) {
            setDefaultValues({ firstname: userDetails.firstname, lastname: userDetails.lastname || null });
            setValue('firstname', userDetails.firstname); // Set the default value
            setValue('lastname', userDetails.lastname || null); // Set the default value
        }

    }, [setValue, userDetails]);


    return (loading ?
        (<div className="w-full flex justify-center px-2 md:px-4 py-5">
            <Loader />
        </div>) : userDetails &&
        <div className="space-y-6 px-6 py-5">
            <div>
                <form noValidate={true} onSubmit={handleSubmit(submitInfo)}>
                    <div className="flex items-baseline" aria-labelledby="Update Name" aria-placeholder="Update Personal Information">
                        <p className="text-base font-bold tracking-tight text-gray-900">Personal Information</p>
                        <button type="button" onClick={toggleEditMode} className="ms-4 text-sm font-medium tracking-tight text-indigo-600"> {personalInfoEditMode ? 'Cancel' : 'Edit'}</button>
                    </div>
                    <div className="grid items-center md:grid-cols-3 gap-3 md:gap-6 mt-4 mb-2">
                        <div className="relative">
                            <InlineInputAddress label={`${personalInfoEditMode ? "Firstname" : ""}`} disabled={!personalInfoEditMode} classname="uppercase !text-gray-500" autoComplete="off" {...register("firstname", { ...nameValidate })} />
                        </div>
                        {userDetails && userDetails.lastname &&
                            <div className="relative">
                                <InlineInputAddress label={`${personalInfoEditMode ? "Lastname" : ""}`} disabled={!personalInfoEditMode} classname="uppercase !text-gray-500" autoComplete="off" {...register("lastname", { required: "Lastname is required." })} />
                            </div>
                        }
                        <div className="relative">
                            <button type="submit" disabled={isSubmitting} className={`mx-auto ${personalInfoEditMode ? "inline" : "hidden"} py-3 px-5 rounded-md border-[1px] bg-indigo-600 hover:bg-indigo-700 focus:ring-4 focus:border-indigo-100 text-sm font-medium text-white shadow-md`} style={{ borderColor: "#0000" }}>{isSubmitting ? "Saving..." : "Save"}</button>
                        </div>
                    </div>
                </form>
            </div>
            <div>
                <EmailAddressForm />
            </div>
        </div>
    )
}

export default UserProfile;